const Music = () => {
  return (
    <svg width="18" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity=".4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.85 17.273c1.74 0 3.15-1.425 3.15-3.182V.93a.9.9 0 0 0-1.106-.905L5.228 2.791c-.402.095-.677.449-.728.846v10.306a3.11 3.11 0 0 0-1.35-.306C1.41 13.637 0 15.06 0 16.818 0 18.576 1.41 20 3.15 20s3.15-1.424 3.15-3.182V8.041l9.9-2.348v5.523a3.112 3.112 0 0 0-1.35-.307c-1.74 0-3.15 1.425-3.15 3.182s1.41 3.182 3.15 3.182ZM6.3 6.173V4.404l9.9-2.347v1.768L6.3 6.173Zm9.9 7.918c0-.753-.604-1.364-1.35-1.364-.746 0-1.35.611-1.35 1.364 0 .753.604 1.364 1.35 1.364.746 0 1.35-.61 1.35-1.364ZM3.15 15.455c.746 0 1.35.61 1.35 1.363s-.604 1.364-1.35 1.364c-.746 0-1.35-.61-1.35-1.364 0-.753.604-1.363 1.35-1.363Z"
        fill="#fff"
      />
    </svg>
  );
};
export default Music;
